module.exports = __webpack_public_path__ + "static/img/buy_play.8cde6267.png";